import { useTheme } from "@mui/material";
import { useState } from "react";
import { filterMenuItems } from "./navBarAccountMenu-utils";
// Custom hook for managing the behavior of the NavBar account menu
export const useNavBarAccountMenu = ({ menuItems, hideAddresses, hideBillingInformation }) => {
    const theme = useTheme(); // Access the MUI theme for consistent styling
    const [anchorEl, setAnchorEl] = useState(null); // State to manage the menu's anchor element (used to open/close the menu)
    const open = Boolean(anchorEl); // If anchorEl is defined, we know the menu should be open because an anchor element (e.g., a button) is currently set. Otherwise, the menu is closed.
    // Handles the click event to open the menu
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget); // Set the clicked element as the anchor
    };
    // Handles the event to close the menu
    const handleClose = () => {
        setAnchorEl(null); // Reset the anchor element to close the menu
    };
    // Filter the menu items based on the props (e.g., whether to hide addresses or billing information)
    const links = filterMenuItems(menuItems, hideAddresses, hideBillingInformation);
    // Determine if the current location matches any menu item, marking it as active
    const isActiveMenuItem = links.some((link) => {
        if (link.to === location.pathname)
            return true; // Compare menu item path with the current path
        return false;
    });
    // Define menu styles based on whether a menu item is active
    const menuStyles = isActiveMenuItem
        ? {
            textDecoration: "underline",
            textDecorationThickness: "2px",
            textUnderlinePosition: "under",
            textUnderlineOffset: "2px",
            textDecorationColor: theme.palette.primary.main,
            color: theme.palette.common.black, // Set text color for active items
        }
        : {
            color: theme.palette.grey[`A700`], // Use a muted color for inactive items
        };
    // Return the state and handlers to be used in the NavBar component
    return {
        anchorEl,
        handleClick,
        handleClose,
        isActiveMenuItem,
        links,
        menuStyles,
        open, // Boolean indicating whether the menu is open
    };
};
